import accentureLogo from "assets/images/companyLogos/accenture.png";
import accentureWhiteLogo from "assets/images/companyLogos/accentureWhite.png";
import bdoLogo from "assets/images/companyLogos/bdo.png";
import bdoWhiteLogo from "assets/images/companyLogos/bdoWhite.png";
import equinorLogo from "assets/images/companyLogos/equinor.png";
import equinorWhiteLogo from "assets/images/companyLogos/equinorWhite.png";
import swecoLogo from "assets/images/companyLogos/sweco.png";
import swecoWhiteLogo from "assets/images/companyLogos/swecoWhite.png";

interface Partners {
  name: string;
  description: string;
  url: string;
  logo: string;
  whiteLogo: string;
}

// Record containing Bindeleddet NTNU's company partners.
// Follow pattern under if you are adding or changing partners.

export const partners: Record<string, Partners> = {
  Accenture: {
    name: "Accenture",
    description:
      "Accenture er et globalt konsulentselskap som leverer tjenester innen strategi, rådgivning, digitalisering, teknologi, sikkerhet og outsourcing. Med rundt 1000 ansatte i Norge jobber vi i sjiktet mellom business og teknologi for å hjelpe våre kunder øke sin prestasjonsevne og utvikle bærekraftig verdi for samfunnet. Vi driver innovasjon for en forenklet hverdag. Dette gjør vi blant annet gjennom meningsfulle prosjekter som RescueMe, MinKiosk og Kjernejournal, og for kunder som WWF, Norgesgruppen og Statens Vegvesen. For mer informasjon om oss og våre muligheter, besøk oss på www.accenture.no/student",
    url: "https://www.accenture.no/student",
    logo: accentureLogo,
    whiteLogo: accentureWhiteLogo,
  },
  BDO: {
    name: "BDO",
    description:
      "BDO er et internasjonalt rådgivnings- og revisjonsselskap med kontorer over hele Norge. Vi har et bredt og sterkt fagmiljø, med inngående bransjekunnskap. Med mer enn 40 000 store og små virksomheter som kunder har vi opparbeidet en unik forståelse for norsk nærings- og samfunnsliv. Hver dag går vi på jobb for å gjøre en forskjell. En forskjell for virksomheter som trenger en samarbeidspartner som kan gi råd, innsikt og skape trygghet for at beslutninger tas på riktig grunnlag. Vi jobber tett på kundene og hverandre, og er genuint opptatt av å skape et godt arbeidsmiljø. Vi støtter medarbeidernes personlige utvikling, og gjør det mulig for alle medarbeidere å realisere gode ideer og initiativer.",
    url: "https://www.bdo.no/nb-no/karriere/bli-en-del-av-bdo/studenter",
    logo: bdoLogo,
    whiteLogo: bdoWhiteLogo,
  },
  Equinor: {
    name: "Equinor",
    description:
      "Equinor er et internasjonalt energiselskap som har forpliktet seg til langsiktig verdiskapning i en lavkarbon-framtid. Vårt formål er å omdanne naturressurser til energi for mennesker og framgang for samfunnet. Equinors portefølje inkluderer olje og gass, fornybar energi og lavkarbonløsninger, og selskapet har ambisjoner om å bli et klimanøytralt selskap innen 2050. Equinor har hovedkontor i Stavanger, og er den ledende operatøren på norsk kontinentalsokkel. Vi er til stede i rundt 30 land verden over. Vi kan tilby spennende karrieremuligheter, god balanse mellom jobb og privatliv, konkurransedyktig lønn og goder som kan bidra til din langsiktige økonomiske stabilitet – i tillegg til at du vil bidra til samfunnet gjennom jobben du gjør. For i Equinor håndterer vi noe av de største utfordringene verden står overfor, og vi trenger mennesker med en sterk drivkraft. Hvis du ønsker å gjøre en forskjell, bør du jobbe i Equinor.",
    url: "https://www.equinor.com/no/karriere",
    logo: equinorLogo,
    whiteLogo: equinorWhiteLogo,
  },
  Sweco: {
    name: "Sweco",
    description:
      "Ingen vet nøyaktig hvordan fremtiden blir. Én ting er likevel sikkert: Vi møter den best med engasjement og nysgjerrighet, og vi må fortsette å spille hverandre gode. Sweco er for alle som vil forme fremtidens byer og samfunn. Hvis du vil forme morgendagen med oss - besøk www.sweco.no/karriere",
    url: "https://www.sweco.no/karriere/",
    logo: swecoLogo,
    whiteLogo: swecoWhiteLogo,
  },
};
